import { fetchWithAuth } from './fetchWithAuth'

export async function deleteConfig(token: string, id: string): Promise<void> {
  await fetchWithAuth(`/v1/tenant-configs/${id}`, token, { method: 'DELETE' })
}
